import React, { useEffect } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';  // Use the routing components here
import UserPage from './UserPage';
import LoginPage from './LoginPage';
import { getAuthToken } from './utils/storageUtil';
import ProductPage from './ProductPage';
import NewProductPage from './NewProductPage';
import ProductSetPage from './ProductSetPage';
import NewUserPage from './NewUserPage';
import UserProductPage from './UserProductPage';
import NewUserProductPage from './NewUserProductPage';
import WithdrawalPage from './WithdrawalPage';
import OrderPage from './OrderPage';
import SettingsPage from './SettingsPage';
import AdministratorPage from './AdministratorPage';
// import LuckySpinPage from './LuckySpinPage';

const App: React.FC = () => {
  const navigate = useNavigate();  // useNavigate works now because the Router context is available
  const location = useLocation();

  useEffect(() => {
    // Check if the user is logged in by looking for a token in localStorage
    const token = getAuthToken();
    if (!token) {
      navigate('/login');
    }
    if(location.pathname == "/"){
      navigate('/login');
    }
  }, [navigate]);

  return (
    <div>
      <Routes>
        <Route path="/user" element={<UserPage />} />
        <Route path="/user/:id" element={<UserProductPage />} />
        <Route path="/newuser" element={<NewUserPage />} />
        <Route path="/newuserproduct/:id" element={<NewUserProductPage />} />
        <Route path="/product" element={<ProductPage />} />
        <Route path="/product-sets" element={<ProductSetPage />} />
        <Route path="/newproduct" element={<NewProductPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/withdrawal" element={<WithdrawalPage />} />
        <Route path="/orders" element={<OrderPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/administrator" element={<AdministratorPage />} />
        {/* <Route path="/lucky-spin" element={<LuckySpinPage />} /> */}
      </Routes>
    </div>
  );
};

export default App;